export default __webpack_public_path__ + "static/media/non2.75601021.png";